import { pwaConfig } from "../config/pwa"

const INSTALL_DISMISSED_KEY = "starlive_pwa_install_dismissed_at"

function navigatorValue() {
  return typeof window !== "undefined" ? window.navigator : null
}

export function isStandalone() {
  if (typeof window === "undefined") return false
  return Boolean(
    window.matchMedia && window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator && window.navigator.standalone === true
  )
}

export function isIOS() {
  const browser = navigatorValue()
  if (!browser) return false
  return /iPad|iPhone|iPod/i.test(browser.userAgent || "") ||
    browser.platform === "MacIntel" && Number(browser.maxTouchPoints || 0) > 1
}

export function isSafari() {
  const browser = navigatorValue()
  if (!browser) return false
  const userAgent = browser.userAgent || ""
  return /Safari/i.test(userAgent) && !/CriOS|FxiOS|EdgiOS|OPiOS|Android/i.test(userAgent)
}

export function isAndroid() {
  const browser = navigatorValue()
  return Boolean(browser && /Android/i.test(browser.userAgent || ""))
}

export function canShowInstallEntry() {
  if (isStandalone()) return false
  return pwaConfig.ios.enabled && isIOS() && isSafari() || pwaConfig.android.enabled && isAndroid()
}

export function applyPwaDocumentState() {
  if (typeof document === "undefined") return false
  const standalone = isStandalone()
  document.documentElement.classList.toggle("pwa-standalone", standalone)
  if (document.body) document.body.classList.toggle("pwa-standalone", standalone)
  return standalone
}

function readDismissedAt() {
  try {
    return Number(window.localStorage.getItem(INSTALL_DISMISSED_KEY) || 0)
  } catch (error) {
    return 0
  }
}

export function rememberInstallGuideDismissal(now = Date.now()) {
  try {
    window.localStorage.setItem(INSTALL_DISMISSED_KEY, String(now))
  } catch (error) {
    // Private browsing or storage policies must not block the website.
  }
}

export function shouldAutoShowInstallGuide(now = Date.now()) {
  if (!pwaConfig.installGuide.enabled || isStandalone() || !isIOS() || !isSafari()) return false
  const intervalMs = pwaConfig.installGuide.intervalDays * 24 * 60 * 60 * 1000
  const dismissedAt = readDismissedAt()
  return !dismissedAt || now - dismissedAt >= intervalMs
}

export function resolveInstallMode(hasAndroidPrompt = false) {
  if (pwaConfig.ios.enabled && isIOS() && isSafari()) return "ios"
  if (pwaConfig.android.enabled && (hasAndroidPrompt || isAndroid())) return "android"
  return "unsupported"
}
